'use client'

type CesiumProjectPopupProps = {
    title: string;
    thumbnail?: string;
    url?: string;
    x: number;
    y: number;
};

// Chỉ cho phép http(s) tuyệt đối hoặc đường dẫn nội bộ bắt đầu bằng một dấu "/".
// Chặn: javascript:, data:, và URL protocol-relative như //evil.com hoặc /\evil.com
const sanitizeUrl = (rawUrl?: string): string => {
    if (!rawUrl) return '#';
    const trimmed = rawUrl.trim();
    if (/^(https?:\/\/|\/(?![\/\\]))/i.test(trimmed)) {
        return trimmed;
    }
    return '#';
};

const CesiumProjectPopup = ({ title, thumbnail, url, x, y }: CesiumProjectPopupProps) => {
    const href = sanitizeUrl(url);

    return (
        <div
            style={{ left: x, top: y, transform: "translate(-50%, calc(-100% - 28px))" }}
            className="pointer-events-auto absolute z-20 w-[280px] overflow-hidden rounded-[14px] bg-white shadow-2xl"
        >
            <div className="h-[140px] bg-gray-100">
                {thumbnail && <img src={thumbnail} alt="" className="h-full w-full object-cover" />}
            </div>
            <div className="p-3">
                <div className="mb-3 text-sm font-bold uppercase leading-snug text-gray-950">{title}</div>
                <a
                    href={href}
                    target={href !== '#' ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    className="block rounded-md bg-[#008a00] px-3 py-2 text-center text-xs font-semibold text-white"
                >
                    Khám phá 360
                </a>
            </div>
        </div>
    );
};

export default CesiumProjectPopup;